<template>
  <div>
    <b-card-actions
      :show-loading="saving || fetching"
      action-collapse
      action-refresh
      :title="$t('Lançamentos de Disputas/Ajustes')"
      @refresh="getAdjustment"
    >
      <b-table
        ref="reconciliation-adjustment-items-table"
        show-empty
        responsive
        striped
        class="bordered"
        :empty-text="getEmptyTableMessage($tc('RECONCILIATION_ITEM.NAME'), 'male')"
        :fields="fields"
        :items="reconciliationAdjustmentItems"
      >
        <template #thead-top>
          <b-tr>
            <b-th
              variant="primary"
              colspan="7"
            >
              {{ $t('Transação Stripe') }}
            </b-th>
          </b-tr>
        </template>

        <template #cell(adjustmentId)="row">
          <span :title="row.item.description">{{
            row.item.adjustmentId
          }}</span>
        </template>

        <template #custom-foot>
          <tr>
            <th colspan="4" />
            <th class="text-right">
              {{ stripeTotalValue | currency }}
            </th>
            <th class="text-right">
              {{ stripeTotalCommission | currency }}
            </th>
            <th class="text-right">
              {{ stripeTotal | currency }}
            </th>
          </tr>
        </template>
      </b-table>

    </b-card-actions>
  </div>
</template>

<script>
import { BTable, BTr, BTh } from 'bootstrap-vue'
import BCardActions from '@core/components/b-card-actions/BCardActions.vue'
import { mapState, mapGetters } from 'vuex'
import { reconciliationDomains } from '@/mixins'

export default {
  components: {
    BTable,
    BTr,
    BTh,
    BCardActions,
  },

  mixins: [reconciliationDomains],

  props: {
    saving: {
      type: Boolean,
      default: false,
    },
    fetching: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState('pages/financial/reconciliation/stripe/maintain', [
      'reconciliationAdjustmentItems',
      'summaryAdjustmentFields',
      'sorting',
    ]),

    ...mapGetters('app', ['paymentMethodsOptions']),

    stripeTotalValue() {
      return this.summaryAdjustmentFields?.stripeTotalValue?.value
    },
    stripeTotalCommission() {
      return this.summaryAdjustmentFields?.stripeTotalCommission?.value
    },
    stripeTotal() {
      return this.summaryAdjustmentFields?.stripeTotal?.value
    },

    fields() {
      return [
        {
          label: this.$t('Disputa/Ajuste'),
          key: 'adjustmentId',
          tdClass: 'text-left',
          sortable: true,
        },
        {
          label: this.$t('NSU'),
          key: 'paymentMethodId',
          tdClass: 'text-left',
          sortable: true,
        },
        {
          label: this.$t('Transação'),
          key: 'paymentIntentId',
          tdClass: 'text-left',
          sortable: true,
        },
        {
          label: this.$t('Cobrança'),
          key: 'chargeId',
          tdClass: 'text-left',
          sortable: true,
        },
        {
          label: this.$t('Valor'),
          key: 'amount',
          tdClass: 'text-right',
          formatter: value => this.$options.filters.currency(value),
          sortable: true,
        },
        {
          label: this.$t('Comissão'),
          key: 'fee',
          tdClass: 'text-right',
          formatter: value => this.$options.filters.currency(value),
          sortable: true,
        },
        {
          label: this.$t('Liquido'),
          key: 'net',
          tdClass: 'text-right',
          formatter: value => this.$options.filters.currency(value),
          sortable: true,
        }
      ]
    }
  },

  mounted() {
  },

  methods: {
    getAdjustment() {
      this.$emit('get-data')
    },

    resetFiltersLocal() {
      this.getAdjustment()
    },
  },
}
</script>

<style></style>
